export const getItem = key => {
  try {
    const item = localStorage.getItem(key)
    if (item === null) {
      return null
    }
    // Пытаемся распарсить как JSON
    try {
      return JSON.parse(item)
    } catch (e) {
      // Если не JSON, возвращаем как строку
      return item
    }
  } catch (error) {
    return null
  }
}
export const setItem = (key, data) => {
  try {
    if (data === null || data === undefined) {
      localStorage.removeItem(key)
      return
    }
    // Если это строка, сохраняем как JSON строку
    localStorage.setItem(key, JSON.stringify(data))
  } catch (error) {
    console.log('error saving data in localStorage', error)
    return error
  }
}
